import { useEffect } from "react";
import { Planny_Website_Url } from "../../infrastructure/config/plannyWebsiteConfig";

const Page_Title = "Обектът не е намерен | Planny";

/**
 * Data for the "studio not found" screen. The address the visitor opened is echoed back so they
 * can compare it with the link they were given — a mistyped domain is the most common cause.
 */
export const useStudioNotFound = () => {
  // Set directly rather than through react-head: on /invalid-domain this screen renders
  // without any providers (see index.tsx).
  useEffect(() => {
    document.title = Page_Title;
  }, []);

  return {
    address: window.location.host,
    plannyWebsiteUrl: Planny_Website_Url,
  };
};
